import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { message } from 'antd';

import AppointmentForm from './../components/AppointmentForm';
import UserForm from './../components/UserForm';
import { getAppointmentServices, appointmentValidate } from '../actions/appointment';
import {
    getSchedules,
    selectSchedule,
    selectCabinet,
    selectService,
    resetSchedule,
    selectGender
} from '../actions/schedule';

import { loadPageText } from '../actions/AppointmentPageText';

const mapStateToProps = state => {
    return {
        pageText: state.AppointmentPageTextReducer.text,
        services: {
            data: state.mobileAppointmentReducer.data,
            loading: state.mobileAppointmentReducer.loading
        },
        schedules: {
            cabinetIds: state.mobileScheduleReducer.cabinetIds,
            cabinets: state.mobileScheduleReducer.cabinets,
            offset: state.mobileScheduleReducer.offset,
            selectedServiceId: state.mobileScheduleReducer.selectedServiceId,
            selectedCabinetId: state.mobileScheduleReducer.selectedCabinetId,
            selectedSchedule: state.mobileScheduleReducer.selectedSchedule,
            selectedGender: state.mobileScheduleReducer.selectedGender,
        }
    };
};
const mapDispatchToProps = dispatch => bindActionCreators({
    getAppointmentServices,
    appointmentValidate,
    getSchedules,
    selectSchedule,
    selectCabinet,
    selectService,
    resetSchedule,
    selectGender,
    loadPageText
}, dispatch);


export class AppointmentFormContainer extends React.Component {
    state = {
        currentForm: 0
    };

    componentDidMount() {
        this.props.getAppointmentServices();
        this.props.loadPageText();
    }

    getSchedules = (serviceId, gender = this.props.schedules.selectedGender, offset = this.props.schedules.offset) => {
        this.props.getSchedules({id: serviceId, gender: gender, offset});
    };

    next = () => this.setState({ currentForm: 1 });

    prev = () => this.setState({ currentForm: 0 });

    handleSubmit = (values, errorCallback) => {
        const { selectedSchedule } = this.props.schedules;
        const queryData = {
            ...values,
            cabinet_service_id: this.props.schedules.selectedCabinetId,
            date: selectedSchedule.date,
            time: selectedSchedule.timeStart,
        };

        this.props.appointmentValidate(queryData, (data) => {
            this.props.resetSchedule();
            this.setState(
                () => ({ currentForm: 0 }),
                () => {
                    message.success(
                        (<span>
                            Вы записаны на медицинский осмотр в "Городской Центр Медосмотра"
                            <br/><span className="tag-success">{data.date}</span> начало оформления в &nbsp;<span className="tag-success">{data.time}</span>.
                            <br/> Ознакомьтесь, пожалуйста, с <a
                            href="https://gormedosmotr.ru/patients/">памяткой</a> для прохождения медосмотра.
                            <br/>
                            <br/>
                            <b>Будьте на связи с МАКС-ботом</b>
                            <p>
                                Получайте уведомления о записях, результатах анализов и важных новостях клиники. Это быстро, удобно и бесплатно
                            </p>
                            <a href="https://max.ru/id5402556132_bot" style={{
                                display: 'inline-block',
                                padding: '10px 20px',
                                background: '#457cf0',
                                color: '#fff'
                            }}>Запустить бота</a>
                        </span>),
                        20
                    );
                }
            )
        }, (errors) => {
            if (errors.msg != null) {
                message.error(
                    (<span>{errors.msg}
                        <br/><span>Для возможности записи свяжитесь с нами.</span>
                        <br/><span>Номер телефона оператора +7 (383) 209-03-01 или напишите на почту: info@gormedosmotr.ru</span>
                        </span>),
                    20
                );
            } else {
                errorCallback(errors);
            }
        });
    };

    render() {
        const { currentForm } = this.state;
        const { services, schedules } = this.props;
        return (
            <div>
                {currentForm === 0 ? (
                    <AppointmentForm
                        services={services.data}
                        schedules={schedules}
                        getSchedules={this.getSchedules}
                        handleSelectService={this.props.selectService}
                        selectSchedule={this.props.selectSchedule}
                        handleSelectCabinet={this.props.selectCabinet}
                        handleSelectGender={this.props.selectGender}
                        next={this.next}
                        pageText={this.props.pageText}
                    />
                ) : (
                    <UserForm
                        handleSubmit={this.handleSubmit}
                        selectedGender={this.props.schedules.selectedGender}
                        prev={this.prev}
                    />
                )}
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentFormContainer);



// WEBPACK FOOTER //
// frontend/src/modules/mobile/containers/AppointmentFormContainer.jsx